__turbopack_context__.v({
  "accordion": "AccordionSection-module-scss-module__A0OWTq__accordion",
  "description": "AccordionSection-module-scss-module__A0OWTq__description",
  "title": "AccordionSection-module-scss-module__A0OWTq__title",
});
